import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

import { exhaustiveGuard } from '@jotta/utils/exhaustive'

import type { TimelineRowDataV2 } from './groupV2'

export function timestampMillisToNanos(timestampMillis: number) {
  return BigInt(timestampMillis) * 1_000_000n
}

export function toNanos(day: Dayjs) {
  return timestampMillisToNanos(day.valueOf())
}

export function nanosFromRow(row: TimelineRowDataV2): bigint {
  switch (row.content) {
    case 'divider':
      return row.timestampNanos
    case 'row':
      return row.elements[Math.floor(row.elements.length / 2)].timestampNanos
    case 'header':
      return timestampMillisToNanos(row.day)
    default:
      return exhaustiveGuard(row)
  }
}

export function fromTimestampNanos(timestampNanos: bigint) {
  return dayjs.utc(timestampNanos / 1_000_000n)
}

export function capturedDay(day: Dayjs) {
  return day.startOf('day').valueOf()
}

export function capturedDayFromNanos(timestampNanos: bigint) {
  return capturedDay(fromTimestampNanos(timestampNanos))
}
